import './CreatePost.styles.scss';

import React, { useContext } from 'react';
import Axios from 'axios';
import UesrContext from '../../contexts/user-context/UserProvider';
import customHistory from '../../history';
import FlashMessageContext from '../../contexts/flash-messages-context/FlashMessageProvider';
import DocTitleScrollTop from '../../utils/DocTitleScrollTop';
import PostForm from './PostForm';

const CreatePost = () => {
	DocTitleScrollTop('Create Post');
	// const sleep = ms => new Promise(r => setTimeout(r, ms));
	const {
		user: { token }
	} = useContext(UesrContext);
	const {
		setFlashMsgIsOpen,
		setFlashMsg,
		setFlashMsgDuration,
		setNotificationSeverity
	} = useContext(FlashMessageContext);

	const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
		// await sleep(500);
		try {
			const { post_title, post_body } = values;
			setSubmitting(true);
			const response = await Axios.post('/create-post', {
				title: post_title,
				body: post_body,
				token
			});
			if (response.status === 200) {
				setSubmitting(false);
				setFlashMsgIsOpen(true);
				setFlashMsg('Created Post Successfully!');
				setFlashMsgDuration(4000);
				setNotificationSeverity('success');
				resetForm();
				customHistory.push(`/post/${response.data}`);
			}
		} catch (e) {
			setSubmitting(false);
			setFlashMsgIsOpen(true);
			setFlashMsg(e.message);
			setFlashMsgDuration(4000);
			setNotificationSeverity('error');
		}
	};

	return (
		<div className="myPage createPostPage">
			<div className="mfaContainer">
				<PostForm
					formInitialValues={{ post_title: '', post_body: '' }}
					handleFormSubmit={handleFormSubmit}
					formTitle="Create Post"
					submitBtnText="Create Post"
				/>
			</div>
		</div>
	);
};

export default CreatePost;
